import { createChildListModalComponent } from 'factories/ChildListModal'
import { tableCellComponents } from 'helpers/listItems'

export default createChildListModalComponent({
  getStorageKey: (self) => 'cycleCounts.selectItems',
  getRowClassName: (self) => (record, index) =>
    !record.inventoryId || record.lockedForCycleCount ? 'table-row-error' : '',
  getRowSelectionCheckboxProps: (self) => (record) => ({
    disabled: !record.inventoryId || record.lockedForCycleCount,
  }),
  tableCellComponents,
})()
